import { SupportFolderSchema } from "@redotech/redo-model/support-folder";
import * as z from "zod";

export const getSupportFolders = {
  name: "getSupportFolders" as const,
  input: z.object({}),
  output: z.object({ folders: z.array(SupportFolderSchema) }),
};
